<template>
    <div class="w-64 h-52 relative noselect">
        <div
            class="absolute bg-cover bg-center inset-0 canvas"
            :style="{
                backgroundImage: 'url(' + image + ')',
            }"
        ></div>
        <!-- mockup -->
        <div class="absolute inset-0 z-10 pointer-events-none ">
            <img
                class="w-full select-none"
                src="../../../assets/product_mockups/3.png"
                alt=""
            />
        </div>
    </div>
</template>

<script>
export default {
    name: "canvasMockup",
    props: {
        image: String,
    },
};
</script>

<style scoped>

.canvas{
    width: 166px;
    height: 155px;
    left: 45px;
    top: 25px;
}
.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}

</style>
